import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { PaymentMethodsEnum } from 'src/app/models/enums/payment-methods.enum';
import { EInvoiceStatusEnum } from 'src/app/models/enums/e-invoice-status.enum';
import { PaymentDetails } from 'src/app/models/payment-details.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Nullable } from 'primeng/ts-helpers';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { EnumKeyValue } from 'src/app/pipes/enumKeyValue.pipe';
import { CountryEnum } from 'src/app/models/enums/countries.enum';
import { GenderEnum } from 'src/app/models/enums/gender.enum';
import { CheckboxModule } from 'primeng/checkbox';
import * as ibantools from 'ibantools';
import { PaymentPreferenceEnum } from 'src/app/models/enums/payment-preference.enum';
import { BelgianBankCodeToBic } from 'src/app/models/enums/belgian-bankcode-to-bic.enum';
import { PostalcodeService } from 'src/app/services/postalcode.service';
import { PostalCode } from 'src/app/models/postalcode.model';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { InvoiceModality } from 'src/app/models/enums/invoice-modality.enum';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { ElectricityType } from 'src/app/models/enums/electricity-type.enum';
import { GasType } from 'src/app/models/enums/gas-type.enum';

@Component({
  selector: 'payment-method-component',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss'],
  standalone: true,
  imports: [
    ButtonModule,
    CardModule,
    CheckboxModule,
    CommonModule,
    EnumKeyValue,
    FormsModule,
    InputGroupModule,
    InputNumberModule,
    InputTextModule,
    RadioButtonModule,
    SelectModule,
    ToastModule
  ],
  providers: [EnumKeyValue, CustomerService, MessageService, PostalcodeService],
})
export class PaymentMethodComponent {

  paymentDetails!: PaymentDetails;
  editMode: boolean = false;

  electricityType!: ElectricityType;
  gasType!: GasType;

  ElectricityType = ElectricityType;
  GasType = GasType;

  PaymentMethod = PaymentMethodsEnum;
  EInvoiceStatus = EInvoiceStatusEnum;

  Gender = GenderEnum;
  Countries = CountryEnum;
  InvoiceModality = InvoiceModality;

  PostalCodes: PostalCode[] = [];

  inputPaymentDetailsIbanValid: Nullable<boolean>;
  inputPaymentDetailsBicValid: Nullable<boolean>;
  inputPaymentDetailsInvoiceModalityValid: Nullable<boolean>;

  showErrorNoIbanFilledIn: boolean = false;
  showErrorNoBicFilledIn: boolean = false;
  showErrorInvalidBic: boolean = false;
  showErrorInvalidIban: boolean = false;

  inputGenderValid: Nullable<boolean>;
  inputFirstNameValid: Nullable<boolean>;
  inputLastNameValid: Nullable<boolean>;
  inputEmailValid: Nullable<boolean>;
  inputTelephoneValid: Nullable<boolean>;
  inputStreetNameValid: Nullable<boolean>;
  inputHouseNumberValid: Nullable<boolean>;
  inputPostalCodeValid: Nullable<boolean>;
  inputLocationValid: Nullable<boolean>;
  inputCountryValid: Nullable<boolean>;

  showErrorNoInvoiceModalityChosen: boolean = false;
  showErrorNoGenderChosen: boolean = false;
  showErrorNoFirstNameFilledIn: boolean = false;
  showErrorNoLastNameFilledIn: boolean = false;
  showErrorNoTelephoneFilledIn: boolean = false;
  showErrorTelephoneWrongFormat: boolean = false;
  showErrorNoEmailFilledIn: boolean = false;
  showErrorEmailWrongFormat: boolean = false;
  showErrorNoStreetNameFilledIn: boolean = false;
  showErrorNoHouseNumberFilledIn: boolean = false;
  showErrorNoPostalCodeFilledIn: boolean = false;
  showErrorPostalCodeInvalid: boolean = false;
  showErrorNoLocationFilledIn: boolean = false;
  showErrorNoCountryFilledIn: boolean = false;

  constructor(private customerService: CustomerService, private enumKeyValue: EnumKeyValue, private messageService: MessageService, private postalcodeService: PostalcodeService) {
    this.customerService.getCustomerByNumber('K2076247-59').subscribe((customer) => {
    });
    
    this.customerService.getInvoicingInfo().subscribe((data) => {
      this.paymentDetails = data;
      this.paymentDetails.checkingAccountHolder = this.paymentDetails.checkingAccountHolder ?? { country: CountryEnum.BE };
    });
        this.postalcodeService.getPostalCodes().subscribe((res: PostalCode[]) => {
            this.PostalCodes = res;
        });
  }

  validateInputs() {
    this.validateInvoiceModalityInput();

    this.validateIbanInput();

    this.validateBicInput();

    this.validateGenderInput();

    this.validateFirstNameInput();

    this.validateLastNameInput();

    this.validateEmailInput();

    this.validateTelephoneNumberInput();

    this.validateStreetNameInput();

    this.validateHouseNumberInput();

    this.validatePostalCodeInput();

    this.validateLocationInput();

    this.validateCountryInput();
  }

  validateCountryInput() {
    this.inputCountryValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.country;
    this.showErrorNoCountryFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.country;
  }

  validateLocationInput() {
    this.inputLocationValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.location;
    this.showErrorNoLocationFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.location;
  }

  validatePostalCodeInput() {
    this.inputPostalCodeValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.postalCode;
    this.showErrorNoPostalCodeFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.postalCode;
  }

  validateHouseNumberInput() {
    this.inputHouseNumberValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.houseNumber;
    this.showErrorNoHouseNumberFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.houseNumber;
  }

  validateStreetNameInput() {
    this.inputStreetNameValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.streetName;
    this.showErrorNoStreetNameFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.streetName;
  }

  validateTelephoneNumberInput() {
    this.inputTelephoneValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      (!!this.paymentDetails.checkingAccountHolder.telephone &&
        (!!this.paymentDetails.checkingAccountHolder.telephone.match(
          /^[+][3][1-2][0-9]{8}$/
        ) ||
          !!this.paymentDetails.checkingAccountHolder.telephone.match(
            /^[+][3][1-2][4][0-9]{8}$/
          )));
    this.showErrorNoTelephoneFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.telephone;
    this.showErrorTelephoneWrongFormat =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !!this.paymentDetails.checkingAccountHolder.telephone &&
      !this.paymentDetails.checkingAccountHolder.telephone.match(
        /^[+][3][1-2][0-9]{8}$/
      ) &&
      !this.paymentDetails.checkingAccountHolder.telephone.match(
        /^[+][3][1-2][4][0-9]{8}$/
      );
  }

  validateEmailInput() {
    this.inputEmailValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      (!!this.paymentDetails.checkingAccountHolder.email &&
        !!this.paymentDetails.checkingAccountHolder.email.match(
          /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/
        ));
    this.showErrorNoEmailFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.email;
    this.showErrorEmailWrongFormat =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !!this.paymentDetails.checkingAccountHolder.email &&
      !this.paymentDetails.checkingAccountHolder.email.match(
        /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/
      );
  }

  validateLastNameInput() {
    this.inputLastNameValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.lastName;
    this.showErrorNoLastNameFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.lastName;
  }

  validateFirstNameInput() {
    this.inputFirstNameValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.firstName;
    this.showErrorNoFirstNameFilledIn =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.firstName;
  }

  validateGenderInput() {
    this.inputGenderValid =
      !this.paymentDetails.checkingAccountOnSomeoneElsesName ||
      !!this.paymentDetails.checkingAccountHolder.gender;
    this.showErrorNoGenderChosen =
      this.paymentDetails.checkingAccountOnSomeoneElsesName &&
      !this.paymentDetails.checkingAccountHolder.gender;
  }

  validateBicInput() {
    this.inputPaymentDetailsBicValid =
      this.paymentDetails.paymentPreference !=
        PaymentPreferenceEnum['Ik verkies domicilliëring'] ||
      (!!this.paymentDetails.bic &&
        ibantools.isValidBIC(this.paymentDetails.bic));
    this.showErrorNoBicFilledIn =
      (this.paymentDetails.paymentPreference == 0 ||
        this.paymentDetails.paymentPreference == null ||
        this.paymentDetails.paymentPreference == undefined ||
        this.paymentDetails.paymentPreference ==
          PaymentPreferenceEnum['Ik verkies domicilliëring']) &&
      !this.paymentDetails.bic;
    this.showErrorInvalidBic =
      !!this.paymentDetails.bic &&
      !/^[A-Z]{4}[A-Z]{2}([A-Z0-9]{2})?$/.test(this.paymentDetails.bic);
  }

  validateIbanInput() {
    this.inputPaymentDetailsIbanValid =
      !!this.paymentDetails.iban &&
      ibantools.isValidIBAN(this.paymentDetails.iban);
    this.showErrorNoIbanFilledIn = !this.paymentDetails.iban;
    this.showErrorInvalidIban =
      !!this.paymentDetails.iban &&
      !ibantools.isValidIBAN(this.paymentDetails.iban);
    var iban = ibantools.extractIBAN(this.paymentDetails.iban);
    this.paymentDetails.bic = this.enumKeyValue
      .transform(BelgianBankCodeToBic)
      .find((x) => x.key == '0' + iban.bankIdentifier)?.value;
  }

  validateInvoiceModalityInput() {
    this.inputPaymentDetailsInvoiceModalityValid = (this.paymentDetails.invoiceModality != 0 && this.paymentDetails.invoiceModality != null && this.paymentDetails.invoiceModality != undefined);
    this.showErrorNoInvoiceModalityChosen = (this.paymentDetails.invoiceModality == 0 || this.paymentDetails.invoiceModality == null || this.paymentDetails.invoiceModality == undefined);
  }

  validateForm() {
    this.validateInputs();
    return (
      this.inputPaymentDetailsIbanValid &&
      this.inputPaymentDetailsBicValid
    );
  }

  getNameFromPostalCode(postalCode: string | number | undefined): string {
    return this.PostalCodes.find((p) => p.code == postalCode)?.name ?? '';
  }

  getPostalCodeFromName(name: string): string {
    return this.PostalCodes.find((p) => p.name == name)?.code ?? '0';
  }

  editPaymentMethod() {
    if (this.validateForm()) {
      this.customerService.updateCustomerInvoicingInfo(this.paymentDetails).toPromise().then(() => {
        this.messageService.add({ severity: 'success', summary: 'Betaalmethode aangepast', detail: 'Uw betaalmethode is aangepast.' });
        this.customerService.getInvoicingInfo().subscribe((data) => {
            this.paymentDetails = data;
            this.paymentDetails.checkingAccountHolder = this.paymentDetails.checkingAccountHolder ?? {};
            this.editMode = false;
        });
      }).catch(() => {
        this.messageService.add({ severity: 'error', summary: 'Fout bij aanpassen', detail: 'Er is een fout opgetreden bij het aanpassen van uw betaalmethode.' });
      });
    }
  }

  activateDirectDebit() {
    if (this.validateForm()) {
        this.customerService.updateCustomerInvoicingInfo(this.paymentDetails).toPromise().then(() => {
            this.messageService.add({ severity: 'success', summary: 'Domiciliëring geactiveerd', detail: 'Uw domiciliëring is geactiveerd.' });
            this.customerService.getInvoicingInfo().subscribe((data) => {
                this.paymentDetails = data;
                this.paymentDetails.checkingAccountHolder = this.paymentDetails.checkingAccountHolder ?? {};
            });
        }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Fout bij activatie', detail: 'Er is een fout opgetreden bij het activeren van uw domiciliëring.' });
        });
    }
  }

  deactivateDirectDebit() {
    this.paymentDetails.paymentPreference = PaymentPreferenceEnum['Ik verkies losse overschrijvingen'];
    this.customerService.updateCustomerInvoicingInfo(this.paymentDetails).toPromise().then(() => {
        this.messageService.add({ severity: 'success', summary: 'Domiciliëring gedeactiveerd', detail: 'Uw domiciliëring is gedeactiveerd.' });
        this.customerService.getInvoicingInfo().subscribe((data) => {
            this.paymentDetails = data;
            this.paymentDetails.checkingAccountHolder = this.paymentDetails.checkingAccountHolder ?? {};
        });
    }).catch(() => {
        this.messageService.add({ severity: 'error', summary: 'Fout bij deactivatie', detail: 'Er is een fout opgetreden bij het deactiveren van uw domiciliëring.' });
    });
  }
}
